import {
  ApartmentOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { MdPendingActions } from "react-icons/md";
import { IoIosApps } from "react-icons/io";
import {TbCalendarDue } from "react-icons/tb";
import { Card, Tag } from "antd";
import React from "react";
import dayjs from "dayjs";

const TaskCard = ({ taskData }) => {
  // console.log(taskData, "taskData <<<<<<<<<<");

  const priorityColors = {
    High: "red",
    Medium: "orange",
    Low: "green",
  };

  return (
    <div className="shadow rounded-md w-full ">
      <Card
        title={
          <div className="text-base sm:text-lg text-center lg:text-2xl font-bold dark:text-white" >
            Assigned Tasks
          </div>
        }
        bordered={true}
        className="shadow-md rounded-lg w-full bg-gray-50 dark:bg-gray-800 dark:border-black dark:text-white"
      >
        <div className="space-y-3 max-h-64 w-full overflow-y-auto">
          {taskData.length == 0 ? (
            <div className="bg-gray-50 dark:bg-darkgray hover:bg-gray-100 dark:hover:bg-lightgrey  h-64 transition-all p-3 rounded-lg border border-gray-200">
              <p className="text-sm sm:text-base text-gray-800 dark:text-white flex items-center justify-center gap-1 font-medium break-all">
                No Data Avalaible
              </p>
            </div>
          ) : (
            Array.isArray(taskData) &&
            taskData?.map((task, idx) => (
              <div
                key={idx}
                className="bg-gray-50 dark:bg-darkgray hover:bg-gray-100 dark:hover:bg-lightgrey transition-all p-3 rounded-lg border border-gray-200 dark:text-white"
              >
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-1 gap-4 text-sm lg:text-[12px] 2xl:text-lg">
                  <div className="space-y-1">
                    <p className=" text-gray-800 dark:text-gray-300 flex items-center gap-1 font-medium break-all ">
                      <UserOutlined className="text-gray-500 dark:text-gray-100 " />
                      {task.EMPLOYEE_NAMES}
                    </p>
                    <p className="text-xs sm:text-sm text-yellow-500 flex items-center gap-1 break-words">
                      <MdPendingActions className="text-gray-500 dark:text-gray-100 " />
                      {task.STATUS}
                    </p>
                  </div>
                  <Tag
                    color={priorityColors[task.PRIORITY_TITLE]}
                    className="text-[11px] sm:text-xs px-2 py-0.5 rounded font-medium self-start sm:self-center"
                    style={{ minWidth: "60px", textAlign: "center" }}
                  >
                    {task.PRIORITY_TITLE}
                  </Tag>
                </div>

                <div className="flex items-center gap-1  text-gray-700 dark:text-gray-300 text-sm lg:text-[12px] 2xl:text-lg">
                  <IoIosApps className="text-gray-500 dark:text-gray-100 " />
                  <p className="font-medium truncate w-full">{task.TITLE}</p>
                </div>

                <hr className="my-2" />

                <p className="text-xs text-gray-500 dark:text-gray-300 mt-1 flex justify-between flex-wrap gap-1">
                  <div className="flex gap-1">
                    <MdOutlineAssignmentTurnedIn  className="text-gray-500 dark:text-gray-100 text-[16px]" />
                    Assign:{" "}
                    {task.ASSIGNDATE
                      ? dayjs(task.ASSIGNDATE).format("MMM DD, YYYY")
                      : "No Date Assigned"}
                  </div>
                  <div className="flex gap-1 ">
                    <TbCalendarDue className="text-gray-500 dark:text-gray-100 text-[16px]" />
                    Due:{" "}
                    {task.DUE_DATE
                      ? dayjs(task.DUE_DATE).format("MMM DD, YYYY")
                      : "No Due Date"}
                  </div>
                </p>
              </div>
            ))
          )}
        </div>
      </Card>
    </div>
  );
};

export default TaskCard;
